import { BaseContext } from '@/contexts/BaseContext';
import { useContext, useEffect } from 'react';
export var Portal_Host;

(function (Portal_Host) {
  Portal_Host["Seller_ID_Host"] = "seller-id.tokopedia.com";
  Portal_Host["Shop_ID_Host"] = "shop-id.tokopedia.com";
  Portal_Host["Seller_Host"] = "seller.tiktokglobalshop.com";
  Portal_Host["Shop_Host"] = "shop.tiktok.com";
  Portal_Host["Partner_Row_Host"] = "partner.tiktokshop.com";
  Portal_Host["Partner_Ttp_Host"] = "partner.us.tiktokshop.com";
})(Portal_Host || (Portal_Host = {}));

export const UseCheckIdHost = () => {
  const {
    isIdRegion
  } = useContext(BaseContext);
  useEffect(() => {
    const isSellerIdHost = window.location.host === Portal_Host.Seller_ID_Host;
    const isShopIdHost = window.location.host === Portal_Host.Shop_ID_Host;
    const isSellerHost = window.location.host === Portal_Host.Seller_Host;
    const isShopHost = window.location.host === Portal_Host.Shop_Host;

    if (isSellerHost) {
      return;
    }

    if (isSellerIdHost) {
      window.location.host = Portal_Host.Seller_Host;
      return;
    }

    if (isIdRegion && isShopHost) {
      window.location.host = Portal_Host.Shop_ID_Host;
    } else if (!isIdRegion && isShopIdHost) {
      window.location.host = Portal_Host.Shop_Host;
    }
  }, [isIdRegion]);
};